import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CuadroDialogoComponent } from 'app/componentes/cuadro-dialogo/cuadro-dialogo.component';
import { EmpresaService } from 'app/services/vinculacion/empresa/empresa.service';
import moment = require('moment');


@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.scss']
})
export class EmpresaComponent implements OnInit {

  displayedColumns: string[] = ['orden','fecha', 'titulo', 'estado', 'ver', 'delete'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;

  public datos_avisos: any = [];

  constructor(private serviceempresa: EmpresaService, 
    private dialog: MatDialog, 
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.obtenerDatos()
  }

  obtenerDatos = () =>{
    this.serviceempresa.getEmpresasAvisos().subscribe(response =>{
      this.datos_avisos = response;

      this.datos_avisos.forEach(aviso => {
        aviso.fecha = moment(aviso.fecha).format('YYYY-MM-DD')
      });
      this.dataSource = new MatTableDataSource(this.datos_avisos)
      this.dataSource.sort = this.sort;
    })
  }
  

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  eliminarDato = (id) => {
    this.dialog.open(CuadroDialogoComponent).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.serviceempresa.eliminarEmpresa(id).subscribe(response =>{
          this.obtenerDatos()
        })
      }
  
    })
  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }


  drop(event: CdkDragDrop<string[]>) {
    let i = 1;
    moveItemInArray(this.datos_avisos, event.previousIndex, event.currentIndex);
    this.dataSource = new MatTableDataSource(this.datos_avisos);
    this.dataSource.sort = this.sort;
    this.datos_avisos.reverse()
    this.datos_avisos.forEach(aviso => {
      aviso.orden = i;

      if (aviso.estado == 'ACTIVO') {
        aviso.estado = 1;
      } else {
        aviso.estado = 0;
      }

      this.serviceempresa.actualizarEmpresa(aviso.idEmpresa, aviso).subscribe(response => {
      });


      if (aviso.estado == 1) {
        aviso.estado = 'ACTIVO';
      } else {
        aviso.estado = 'INACTIVO';
      }

      i++;
    });
    this.openSnackBar("EL REGISTRO SE MOVIO CORRECTAMENTE!")
    this.datos_avisos.reverse()
    // this.obtenerDatos()
  }

}
